import { createFileRoute } from '@tanstack/react-router'

import { UnderConstruction } from '@/components/common/under-construction'

export const Route = createFileRoute('/_app/profile/')({
	component: UnderConstruction,
})
